import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#empty" }),
    /*#__PURE__*/_createTextVNode(" Empty ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Placeholder hints for empty states. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUICustomImage = _resolveComponent("EUICustomImage")
  const _component_EUIImageSize = _resolveComponent("EUIImageSize")
  const _component_EUIBottomContent = _resolveComponent("EUIBottomContent")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUICustomImage),
    _createVNode(_component_EUIImageSize),
    _createVNode(_component_EUIBottomContent)
  ], 64))
}